import React from 'react';
import HeaderComponent from '../components/Header';
import IWantItSection from '../components/IWantItSection';
import HowWorksSection from '../components/HowWorksSection';
import MotelsParticipatingSection from '../components/MotelsParticipatingSection'
import ShareCouponSection from '../components/ShareCouponSection';
import FooterComponent from '../components/Footer';
import MeetSixtyniteSection from '../components/MeetSixtyniteSection';

const Home = () => {
  return (
    <>
      <HeaderComponent/>
      <IWantItSection/>
      <HowWorksSection/>
      <MotelsParticipatingSection/>
      <ShareCouponSection/>
      <MeetSixtyniteSection/>
      <FooterComponent/>
    </>
  );
};


export default Home;